<template>
  <div :id="$attrs['id']" :class="[[$attrs['class'], gridClasses], {'hm-gender--disabled': disabledCombined}]" class="hm-gender">
    <div class="hm-gender__options__wrapper">
      <div class="hm-gender__options">
        <div :class="{'active': internalValue === 'Male' }" class="hm-gender__option" @click="internalValue = 'Male'">
          <icon icon="male"></icon>
        </div>
        <div :class="{'active': internalValue === 'Female' }" class="hm-gender__option" @click="internalValue = 'Female'">
          <icon icon="female"></icon>
        </div>
        <div :class="{'active': internalValue === 'Unknown' || internalValue === null }" class="hm-gender__option" @click="internalValue = 'Unknown'">
          <icon icon="fill-unknown"></icon>
        </div>
      </div>
    </div>
    <div class="hm-gender__help" v-html="help" />
    <div class="hm-gender__label" v-html="label" />
  </div>
</template>

<script>

import HmInputMixin from '@/mixins/HmInputMixin';
import GridMixin from '@/mixins/GridMixin';

export default {
  name: 'HmGender',

  mixins: [HmInputMixin, GridMixin],

  methods: {
    toggleState: function () {
      if (!this.disabledCombined) {
        this.internalValue = !this.internalValue;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '~styles/import';
  .hm-gender {
    position: relative;
    padding-top: 0.6rem;
    &--disabled {
      pointer-events: none;
      .hm-gender {
        &__option {
          background-color: $lightgray;
        }
      }
    }
    &__options {
      display: grid;
      grid-template-columns: repeat(3, minmax(6.85rem, 1fr));
      // grid-template-columns: repeat(3, 1fr);
      border: 0.1rem solid $middlegray;
      border-radius: 0.3rem;
      align-items: center;
      justify-items: center;
      &__wrapper {
        display: flex;
        width: auto;
      }
    }
    &__option {
      border-right: 0.1rem solid $middlegray;
      width: 100%;
      display: grid;
      align-items: center;
      justify-items: center;
      &:last-of-type {
        border-right: none;
      }
      @include icon-color($middlegray);
      .hm-icon {
        width: 3rem;
        height: 3rem;
      }
      &.active {
        @include icon-color($text);
      }
      &:hover {
        cursor: pointer;
        @include icon-color($text);
      }
    }
    &__help {
      color: $gray;
      font-size: 1.1rem;
      padding-left: 1rem;
      height: 1.4rem;
      line-height: 1.4rem;
      margin-bottom: 0.3rem;
      margin-top: 0.3rem;
    }
    &__label {
      position: absolute;
      top: 0;
      left: 0.6rem;
      font-size: 1.1rem;
      color: $gray;
      transition: all 0.2s ease;
      z-index: 2;
      pointer-events: none;
      background-color: $white;
      padding: 0 0.4rem;
      border-radius: 0.3rem;
      will-change: top, font-size;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/lib/inputs/HmGender.vue